import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/react";
import { CraAttribute, CraAttributeType } from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { MapColoringLegendItem } from "./MapColoringLegendItem";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";
import {
  mapGradient,
  mapGradientEnd,
  mapGradientStart,
  mapGradientStep,
} from "../../../../map/utils/map-utils";

interface Props {
  attribute: CraAttribute;
}
export const CraColoringAttribute: React.FC<Props> = ({ attribute }) => {
  if (attribute.type === CraAttributeType.Select) {
    const nOptions = attribute.options.length;

    return (
      <>
        {attribute.options.map((option, i) => {
          return (
            <MapColoringLegendItem key={i} color={mapGradientStep(nOptions, i)}>
              {CraAttributeUtils.getOptionLabel(option.value)}
            </MapColoringLegendItem>
          );
        })}
      </>
    );
  } else if (attribute.type === CraAttributeType.TextArea) {
    return (
      <>
        <MapColoringLegendItem color={mapGradientStart}>
          {t(`map:mapColoring.textArea.filled`)}
        </MapColoringLegendItem>
        <MapColoringLegendItem color={mapGradientEnd}>
          {t(`map:mapColoring.textArea.empty`)}
        </MapColoringLegendItem>
      </>
    );
  } else if (attribute.type === CraAttributeType.Number) {
    const nSteps = 9;
    return (
      <HStack alignItems="stretch" fontSize="xs" my={1}>
        <Flex
          flexShrink={0}
          w="6px"
          flexDir="column"
          borderRadius="3px"
          overflow="hidden"
        >
          {[...Array(nSteps).keys()].map((i) => (
            <Box
              key={i}
              flex={1}
              bgColor={`#${mapGradient.hsvAt(i / nSteps).toHex()}`}
            />
          ))}
        </Flex>
        <Stack gap={4}>
          <Text>{`0 km/h`}</Text>
          <Text>{`> = 90 km/h`}</Text>
        </Stack>
      </HStack>
    );
  }

  return null;
};
